import {onDomReady} from "../../components/dynamic/observer";

class ErpTasks {
    constructor(selector = '[data-task-item]') {
        this.items = Array.from(document.querySelectorAll(selector));
        if (!this.items.length) return;

        this.bindEvents();
    }

    bindEvents() {
        this.items.forEach(item => {
            item.addEventListener('click', () => this.onItemClick(item));
        });
    }

    onItemClick(item) {
        if (item.classList.contains('_active')) {
            item.classList.remove('_active');
            return;
        }

        this.items.forEach(i => i.classList.remove('_active'));
        item.classList.add('_active');
    }
}

document.addEventListener('DOMContentLoaded', () => {

});

onDomReady(() => {
    new ErpTasks('[data-task-item]');
})
